import { Injectable } from "@angular/core";
import { PrelevementSurface } from "src/app/domain/Surface/prelevement-surface";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { PrelevementRepository } from "./prelevement.repository";
import { PrelevementSurfaceEntity } from "../prelevement-surface.entity";
import { ZoneEntity } from "../zone.entity";
import { AppareilRepository } from "./appareil.repository";

@Injectable({
    providedIn: 'root',
})
export class PrelevementSurfaceRepository {

    constructor(private prelevementRepository: PrelevementRepository,
    ) { }

    async getPrelevementSurfaceEntityById(id: number) {
        return await db.prelevementSurfaces.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getPrelevementSurfaceById(id: number) {
        return await db.prelevementSurfaces.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, PrelevementSurfaceEntity, PrelevementSurface);

            if (ze?.PrelevementId) {
                z.Prelevement = await this.prelevementRepository.getPrelevementById(ze?.PrelevementId)
            }

            return z;
        });
    }

    async attachPrelevementSurface(ps: PrelevementSurface, zoneEntity: ZoneEntity) {
        let psId: number;
        const pse = mapper.map(ps, PrelevementSurface, PrelevementSurfaceEntity);

        // const ze = await this.zoneRepository.getZoneEntityById(zoneEntity);
        psId = await db.prelevementSurfaces.add(pse);
        zoneEntity.PrelevementSurfaceIds = zoneEntity?.PrelevementSurfaceIds ? [...zoneEntity.PrelevementSurfaceIds, psId] : [psId]
        await db.zones.update(zoneEntity.Id!, {
            PrelevementSurfaceIds: zoneEntity?.PrelevementSurfaceIds
        });

        if (ps.Prelevement) {
            await this.prelevementRepository.attachPrelevementToSurface(ps.Prelevement, psId);
        }

        return psId;
    }
}